"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.thicknesses = exports.sizes = exports["default"] = exports.SIZE_MAP = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
var _merge, _thicknesses;
var spinnerStyles = _theme["default"].components.Spinner;
var SIZE_MAP = exports.SIZE_MAP = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  '2xl': '2xl',
  '3xl': '3xl',
  '4xl': '4xl',
  '5xl': '5xl',
  '6xl': '6xl',
  '7xl': '7xl',
  '8xl': '8xl',
  '9xl': '9xl',
  '10xl': '10xl'
};
var sizes = exports.sizes = (0, _merge2["default"])(spinnerStyles.sizes, (_merge = {}, (0, _defineProperty2["default"])(_merge, SIZE_MAP['2xl'], {
  w: '4rem',
  h: '4rem'
}), (0, _defineProperty2["default"])(_merge, SIZE_MAP['3xl'], {
  w: '5rem',
  h: '5rem'
}), (0, _defineProperty2["default"])(_merge, SIZE_MAP['4xl'], {
  w: '6rem',
  h: '6rem'
}), (0, _defineProperty2["default"])(_merge, SIZE_MAP['5xl'], {
  w: '7rem',
  h: '7rem'
}), (0, _defineProperty2["default"])(_merge, SIZE_MAP['6xl'], {
  w: '8rem',
  h: '8rem'
}), (0, _defineProperty2["default"])(_merge, SIZE_MAP['7xl'], {
  w: '9rem',
  h: '9rem'
}), (0, _defineProperty2["default"])(_merge, SIZE_MAP['8xl'], {
  w: '10rem',
  h: '10rem'
}), (0, _defineProperty2["default"])(_merge, SIZE_MAP['9xl'], {
  w: '11rem',
  h: '11rem'
}), (0, _defineProperty2["default"])(_merge, SIZE_MAP['10xl'], {
  w: '12rem',
  h: '12rem'
}), _merge));
var thicknesses = exports.thicknesses = (_thicknesses = {}, (0, _defineProperty2["default"])(_thicknesses, SIZE_MAP.xl, 3), (0, _defineProperty2["default"])(_thicknesses, SIZE_MAP['2xl'], 4), (0, _defineProperty2["default"])(_thicknesses, SIZE_MAP['3xl'], 5), (0, _defineProperty2["default"])(_thicknesses, SIZE_MAP['4xl'], 6), (0, _defineProperty2["default"])(_thicknesses, SIZE_MAP['5xl'], 7), (0, _defineProperty2["default"])(_thicknesses, SIZE_MAP['6xl'], 8), (0, _defineProperty2["default"])(_thicknesses, SIZE_MAP['7xl'], 9), (0, _defineProperty2["default"])(_thicknesses, SIZE_MAP['8xl'], 10), (0, _defineProperty2["default"])(_thicknesses, SIZE_MAP['9xl'], 11), (0, _defineProperty2["default"])(_thicknesses, SIZE_MAP['10xl'], 12), _thicknesses);
var defaultProps = {
  speed: '2s',
  size: SIZE_MAP['2xl'],
  thickness: thicknesses[SIZE_MAP['2xl']]
};
var _default = exports["default"] = {
  sizes: sizes,
  defaultProps: defaultProps
};